import { useButtonLinkStyles } from "./button-link.styles";
import { ButtonLinkProps } from "../types/index";
import { Button } from "@/base/components/index";
import { Link as RouterLink } from "react-router-dom";

export const ButtonLink = ({ to, target, ...props }: ButtonLinkProps) => {
  const { styles } = useButtonLinkStyles();

  return (
    <RouterLink to={to} target={target}>
      <Button className={styles.root} {...props} />
    </RouterLink>
  );
};
